import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Button, Col, Row, Space } from 'antd'
import { selectActionEvent } from 'Store/member-point/selector'
import { selectCurrentUser } from 'Store/user/selector'
import LoadingView from 'Components/modal/LoadingView'
import HomePageLayout from 'Pages/Layout/PageLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import 'antd/es/slider/style'
import { PrimaryButton } from 'Components/button'
import { clearEventAction } from 'Store/member-point/actions'
import { ConfirmDailog, EventModal } from 'Components/modal'
import AllProductConfig from './components/AllProductConfig'
import CustomProductConfig from './components/CustomProductConfig'
import {
  PointConfigData,
  PointConfigDetailReq,
  PointProductConfig,
  UpdatePointConfigReq,
} from 'Store/member-point/types'
import { selectPointConfigDatail } from 'Store/member-point/selector'
import { getPointConfigDetailAPI, updateConfigPointAPI } from 'Store/member-point/api'
import AppMultiSelect from 'Components/form/AppMultiSelect'
import { DefaultStatus, menuPointConfigChanel, PointConfigType } from 'helpers/constanst'
import { TutorialMemberPoint } from 'helpers/tutorials'
import { AppTutorial } from 'Components/utilities'
import { cloneDeep } from 'lodash'
import { getStaffPermission } from 'helpers/account'

type Props = {} & ReduxProps

const PointConfig: React.FunctionComponent<Props> = props => {
  const { detail, event, currentUser } = props
  const dispatch = useDispatch()
  const detailEvent = detail?.event
  const [confirmSaveDialog, setConfirmSaveDialog] = useState(false)
  const [specialActive, setSpecialActive] = useState(false)
  const [specialConfigData, setSpecialConfigData] = useState([] as PointConfigData[])
  const [allConfigData, setAllConfigData] = useState([] as PointConfigData[])
  const [channel, setChannel] = useState([] as string[])
  const mid = currentUser?.activeMerchant?.id || 0
  const [lastSpecialActive, setLastSpecialActive] = useState(false)
  const [lastAllConfigData, setLastAllConfigData] = useState([] as PointConfigData[])
  // tutorial
  const [showTutorial, setShowTutorial] = useState(false as boolean)
  const steps = TutorialMemberPoint.setting.steps
  const enableTutorial = TutorialMemberPoint.setting.enable

  useEffect(() => {
    onGetDetail()
  }, [])

  const onStartTutorial = () => {
    //save last state
    setLastSpecialActive(specialActive)
    setLastAllConfigData(allConfigData)

    if (allConfigData.length <= 0) {
      const initForm = {
        channel: [],
        criterion: 100,
        id: 0,
        is_all_product: 'yes',
        merchant_id: 0,
        point_type: PointConfigType.AMOUNT,
        points: 1,
        products: [],
        status: DefaultStatus.ACTIVE,
      } as PointConfigData
      setAllConfigData([cloneDeep(initForm)])
    }
    setSpecialActive(true)
    setShowTutorial(true)
  }
  const onEndTutorial = () => {
    setSpecialActive(lastSpecialActive)
    setAllConfigData(lastAllConfigData)
    setShowTutorial(false)
  }

  const convertDetailFormat = (data: PointConfigData[]) => {
    const newData = [] as PointConfigData[]
    data.forEach(item => {
      const products = [] as PointProductConfig[]
      item?.products?.forEach(productItem => {
        const productData = productItem?.product
        products.push({
          picture: productData?.photo || '',
          brand: productData?.brand_name || '',
          code: productData?.code || '',
          product_id: productData?.product_id || 0,
          product_option_id: productData?.product_option_id || 0,
          title: productData?.title || '',
          unit: productData?.unit_name || '',
        })
      })
      newData.push({
        ...item,
        products: products,
      })
    })
    return newData
  }

  const getDefaultActiveIndex = (data: PointConfigData[]) => {
    const number = [] as number[]
    for (let index = 0; index < data.length; index++) {
      number.push(index + 1)
    }
    return number
  }

  console.log('allConfigData', allConfigData)
  console.log('specialConfigData', specialConfigData)

  useEffect(() => {
    console.log('detail?.data', detail?.data)
    if (detail?.data) {
      const productData = convertDetailFormat(detail?.data || [])
      const allProduct: PointConfigData[] = productData.filter(item => item.is_all_product === 'yes')
      setAllConfigData(allProduct || [])
      const specialProduct: PointConfigData[] = productData.filter(item => item.is_all_product === 'no')
      setSpecialConfigData(specialProduct || [])
      setChannel((allProduct && allProduct[0]?.channel) || [])
      setSpecialActive((specialProduct && specialProduct[0]?.status === DefaultStatus.ACTIVE) || false)
    }
  }, [detail?.data])

  const onGetDetail = (): void => {
    const req: PointConfigDetailReq = {
      mid,
    }
    dispatch(getPointConfigDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const formatReq = () => {
    const newReq = [] as PointConfigData[]
    allConfigData?.forEach(item => {
      newReq.push({ ...item, channel: channel, merchant_id: mid })
    })
    specialConfigData?.forEach(item => {
      const productsIds = [] as PointProductConfig[]
      item?.products?.forEach(productItem => {
        productsIds.push({
          product_id: productItem.product_id,
          product_option_id: productItem.product_option_id,
        })
      })
      newReq.push({
        ...item,
        products: productsIds,
        channel: channel,
        merchant_id: mid,
        status: specialActive ? DefaultStatus.ACTIVE : DefaultStatus.INACTIVE,
      })
    })
    return newReq
  }

  const onSave = () => {
    const req: UpdatePointConfigReq = {
      data: formatReq(),
      mid,
    }
    dispatch(updateConfigPointAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onGetDetail()
    onCloseConfirmDailog()
  }

  const onClickSave = () => {
    onOpenConfirmDailog()
  }

  const onOpenConfirmDailog = () => {
    setConfirmSaveDialog(true)
  }

  const onCloseConfirmDailog = () => {
    setConfirmSaveDialog(false)
  }

  const ConfirmSaveDailog = (
    <ConfirmDailog
      title="ยืนยันการบันทึกข้อมูล"
      description="คุณแน่ใจที่จะบันทึกข้อมูลหรือไม่?"
      confirmBtnTxt="บันทึก"
      isShow={confirmSaveDialog}
      handleOk={onSave}
      handleCancel={onCloseConfirmDailog}
    />
  )

  // const findConfigData = (isAllProduct: boolean) => {
  //   return configData && configData.find(item => item.is_all_product === isAllProduct)
  // }
  // const allProductData = findConfigData(true)

  return (
    <HomePageLayout
      selected="point-config"
      title="การตั้งค่าการสะสมคะแนนของร้านคุณ"
      label={''}
      isShowTutorial={showTutorial}
      showTutorial={enableTutorial}
      onClickStart={onStartTutorial}
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row gutter={[16, 8]}>
        <Col span={24}>
          <BoxWrapper>
            <AllProductConfig
              onUpdate={configData => {
                setAllConfigData([{ ...configData }])
              }}
              data={allConfigData ? allConfigData[0] : undefined}
            />
          </BoxWrapper>
        </Col>
        <Col span={24}>
          <BoxWrapper>
            <CustomProductConfig
              onUpdate={configData => setSpecialConfigData(configData)}
              data={specialConfigData}
              isActive={specialActive}
              onUpdateStatus={setSpecialActive}
              isTutorial={showTutorial}
            />
          </BoxWrapper>
        </Col>
        <Col span={24}>
          <BoxWrapper className="ttr-channel">
            <Title>ช่องทางยอดซื้อสินค้าที่จะได้รับคะแนน</Title>
            <AppMultiSelect
              name="discount_type"
              label=""
              isRequired={false}
              isError={false}
              value={channel || []}
              onChange={value => {
                setChannel(value)
              }}
              menu={menuPointConfigChanel}
              mode="multiple"
            />
          </BoxWrapper>
        </Col>
      </Row>
      <br />
      <Row justify="center">
        <Col>
          <Space size="large">
            <MyButton type="primary" onClick={onClickSave} className="ttr-save">
              บันทึกข้อมูล
            </MyButton>
            <PrimaryButton btnType="Cancel" text="ยกเลิก" onClick={onGetDetail} className="ttr-cancel" />
          </Space>
        </Col>
      </Row>

      {ConfirmSaveDailog}
      {enableTutorial && (
        <AppTutorial onCloaseTutorial={onEndTutorial} showTutorial={showTutorial} steps={steps} />
      )}
    </HomePageLayout>
  )
}

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  margin-bottom: 10px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};

  .ant-form-item {
    margin-bottom: 0 !important;
  }
`

const MyButton = styled(Button)`
  height: 45px;
  border-radius: 5px;
`

const Title = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-bottom: 10px;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectActionEvent(state),
    detail: selectPointConfigDatail(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PointConfig)
